import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { RootState } from "../../../store";
import { fetchSuperCategories } from "../../../Redux/filters/slice";

const fallbackCategories = [
  { name: "ALL", label: "All Categories", image: "../../assets/img/categories/allcategories.png" },
  { name: "GROCERIES", label: "Groceries", image: "../../assets/img/categories/groceries.png" },
  { name: "FRESH", label: "Fresh", image: "../../assets/img/categories/fresh.png" },
  { name: "WOMEN", label: "Women", image: "../../assets/img/categories/women.png" },
  { name: "MEN", label: "Men", image: "../../assets/img/categories/men.png" },
  { name: "KIDS", label: "Kids", image: "../../assets/img/categories/kids.png" },
  { name: "BOOKS", label: "Books", image: "../../assets/img/categories/books.png" },
  { name: "TOYS", label: "Kids Toys", image: "../../assets/img/categories/toys.png" },
  { name: "ELECTRONICS", label: "Electronics", image: "../../assets/img/categories/electronics.png" },
  { name: "MOBILES", label: "Mobiles", image: "../../assets/img/categories/mobiles.png" },
  { name: "APPLIANCES", label: "Appliances", image: "../../assets/img/categories/appliances.png" },
  { name: "PERSONAL_CARE", label: "Personal Care", image: "../../assets/img/categories/personalcare.png" },
  { name: "BEAUTY", label: "Beauty", image: "../../assets/img/categories/beauty.png" },
  { name: "FITNESS", label: "Fitness", image: "../../assets/img/categories/fitness.png" },
  { name: "FOOTWEAR", label: "Footwear", image: "../../assets/img/categories/footwear.png" },
  { name: "JEWELLERY", label: "Jewellery", image: "../../assets/img/categories/jewellery.png" },
  { name: "SPORTS", label: "Sports", image: "../../assets/img/categories/sports.png" },
  { name: "ACCESSORIES", label: "Accessories", image: "../../assets/img/categories/accessories.png" },
];

interface Props {
  selectedCategory: string;
  onSelect: (name: string) => void;
}

const MiniCategoriList: React.FC<Props> = ({ selectedCategory, onSelect }) => {
  const dispatch = useAppDispatch();
  const { superCategories } = useAppSelector((state: RootState) => state.filters);

  useEffect(() => {
    dispatch(fetchSuperCategories({ showOnWebsite: true, showOnFilters: true }));
  }, [dispatch]);

  const categories =
    superCategories.data.length > 0
      ? [
          { name: "ALL", label: "All Categories", image: "../../assets/img/categories/allcategories.png" },
          ...superCategories.data.map((cat) => ({
            name: cat.name,
            label: cat.name,
            image: cat.image || "../../assets/img/categories/allcategories.png",
          })),
        ]
      : fallbackCategories;

  const extraCategories = [
    { name: "DEALS", label: "Deals", image: "https://www.shutterstock.com/image-vector/special-offer-banner-sale-template-260nw-2473501733.jpg", route: "/DealsPage" },
    { name: "DIGITAL", label: "Digital Product", image: "https://img.freepik.com/premium-vector/digital-product-shopping-bag-logo-online-store_1019841-74.jpg?semt=ais_incoming&w=740&q=80", route: "/DigitalProduct" },
    { name: "REF_PRODUCTS", label: "Ref Products", image: "../../assets/img/refProduct.jpg", route: "/RefProducts" },
  ];

  return (
    <div
      className="nav flex-column nav-pills me-3 nav-pill-scroll"
      role="tablist"
      aria-orientation="vertical"
    >
      {categories.map((cat) => (
        <button
          key={cat.name}
          className={`nav-link border-bottom${selectedCategory === cat.name ? " active" : ""}`}
          type="button"
          role="tab"
          onClick={() => onSelect(cat.name)}
        >
          <div className="d-flex justify-content-center text-center mb-2">
            <div>
              <div className="bg-light categories-bg-mini mt-1">
                <img
                  alt={cat.label}
                  src={cat.image}
                  className="avatar categories-img-product-mini img-product"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = "../../assets/img/categories/allcategories.png";
                  }}
                />
              </div>
              <div className="lh-1 text-wrap">
                <span className="text-black text-xxxs">
                  <small className="text-bold text-nowrap">{cat.label}</small>
                </span>
              </div>
            </div>
          </div>
        </button>
      ))}
      {extraCategories.map((cat) => (
        <a key={cat.name} href={cat.route} className="nav-link border-bottom text-decoration-none">
          <div className="d-flex justify-content-center text-center mb-2">
            <div>
              <div className="bg-light categories-bg-mini mt-1">
                <img
                  alt={cat.label}
                  src={cat.image}
                  className="avatar categories-img-product-mini img-product"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = "../../assets/img/categories/allcategories.png";
                  }}
                />
              </div>
              <div className="lh-1 text-wrap">
                <span className="text-black text-xxxs">
                  <small className="text-bold text-nowrap">{cat.label}</small>
                </span>
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default MiniCategoriList;
